module.exports = __webpack_public_path__ + "img/mypage_header_coupon.92ec9c6.svg";